import React, { Component } from "react";
import { render } from "react-dom";

import { saveAs } from "file-saver";
import { Packer } from "docx";
import { experiences, education, skills, achievements } from "./data";
import { DocumentCreator } from "./document-generator";

interface CreationWordDocumentProps {}
interface CreationWordDocumentState {
  name: string;
}

class CreationWordDocument extends Component<
  CreationWordDocumentProps,
  CreationWordDocumentState
> {
  constructor(props) {
    super(props);
    this.state = {
      name: "React"
    };
  }

  generate(): void {
    const documentCreator = new DocumentCreator();
    const doc = documentCreator.create([
      experiences,
      education,
      skills,
      achievements
    ]);

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "example.docx");
    });
  }

  render() {
    return (
      <div>
        <p>
          Start editing to see some magic happen :)
          <button onClick={this.generate}>Generate CV with docx!</button>
        </p>
      </div>
    );
  }
}

export default CreationWordDocument;
